import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './layouts/Layout';
import 'react-datetime/css/react-datetime.css';
import 'react-toastify/dist/ReactToastify.css';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
  Observable
} from "@apollo/client";
import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { createUploadLink } from "apollo-upload-client";
import refreshToken from './helpers/refreshToken';
import { toast } from 'react-toastify';
import { logErrorToServer } from './helpers/utils';
import jwt_decode from "jwt-decode";
import globalError from './Error';


const API_URL = process.env.REACT_APP_API_URL + "/query";
const API_WS = process.env.REACT_APP_API_WS + "/query";

const getUserIDFromAccessToken = () => {
  let token = localStorage.getItem('accessToken')
  try {
    const decoded = jwt_decode(token);
    return decoded.id
  } catch (err) {
    return ""
  }
}
const getRoleFromAccessToken = () => {
  let token = localStorage.getItem('accessToken')
  try {
    const decoded = jwt_decode(token);
    return decoded?.role
  } catch (err) {
    return ""
  }
}

const App = () => {
  const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      if (graphQLErrors.find(error => error.message.includes('error jwt'))) {
        return new Observable(observer => {
          refreshToken().then(() => {
            const subscriber = {
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer)
            };
            const newToken = localStorage.getItem('accessToken');

            // Mettez à jour le header avec le nouveau token.
            operation.setContext(({ headers }) => ({
              headers: {
                ...headers,
                Authorization: `Bearer ${newToken}`,
              },
            }));
            //window.location.reload()
            forward(operation).subscribe(subscriber);
          })
            .catch(error => {
              observer.error(error);
            });
        });
      }
      graphQLErrors.forEach(({ message }) => {
        const errorDetails = {
          graphqlErrors: message,
          currentUrl: window.location.href,
          jwt: localStorage?.getItem('accessToken'),
          payload: JSON.stringify(operation?.variables),
          query: operation?.query?.loc?.source?.body,
        };
        let user_id = getUserIDFromAccessToken()
        let role = getRoleFromAccessToken()
        logErrorToServer(errorDetails)
        console.log(message)
        //let devMode = process.env.REACT_APP_DEV_MODE === "1" || process.env.REACT_APP_DEV_MODE === 1
        let err = globalError(message, user_id)
        if(role !== "BORROWER"){
            if (err !== null) {
              return toast.error(err, { autoClose: true })
            }
        }
        
       

      }


      );
    }
    if (networkError) {
      if (networkError.statusCode === 401) {
        alert("Veuillez utiliser une clé API valide X-API-Key");
      }
    };
  });

  const uploadLinkWithUpload = createUploadLink({ uri: API_URL })

  const wsLink = new GraphQLWsLink(createClient({
    url: API_WS,
    connectionParams: () => {
      return {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        "X-API-Key": process.env.REACT_APP_API_KEY
      }
    }
  }));

  const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem('accessToken');
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : "",
        "X-API-Key": process.env.REACT_APP_API_KEY
      }
    }
  });

  const baseOptions = {
    errorPolicy: "all",
    //fetchPolicy: 'cache-and-network',
  }

  const client = new ApolloClient({
    defaultOptions: {
      watchQuery: baseOptions,
      query: { ...baseOptions, fetchPolicy: 'cache-and-network' },
      mutate: baseOptions,
    },
    link: ApolloLink.from([authLink, errorLink, uploadLinkWithUpload, wsLink]),
    cache: new InMemoryCache(),
    name: `${process.env.REACT_APP_NAME}`,
    version: `${process.env.REACT_APP_API_VERSION}`
  });

  return (
    <ApolloProvider client={client}>
      <Router basename={process.env.PUBLIC_URL}>
        <Layout />
      </Router>
    </ApolloProvider>
  );
};

export default App;
